export const salesGaugeData = [
  [
    {
      category: "Total Orders",
      value: 65,
      full: 100,
    },
    {
      category: "Past Orders",
      value: 80,
      full: 100,
    },
    {
      category: "Total Revenue",
      value: 90,
      full: 100,
    },
  ],
  [
    {
      category: "Total Orders",
      value: 65,
      full: 100,
    },
    {
      category: "Past Orders",
      value: 80,
      full: 100,
    },
    {
      category: "Total Revenue",
      value: 90,
      full: 100,
    },
  ],
];

export const getTableDataCriteria = () => {
  return [
    "Country",
    "City",
    "State",
    "Region",
    "ZIP",
    "Location",
    "Age",
    "Gender",
    "Education",
    "Ethnicity/Origin",
    "Marital Status",
    "Income",
    "Homeownership",
    "Values",
    "Interests",
    "Goals",
    "Problems",
    "Brand",
    "Influencers",
  ];
};
